import React from 'react';

/**
 * Which cards are collapsed. Keyed by mode and group rather than by position, so removing an item
 * doesn't collapse a different card and a portfolio card's state doesn't carry to a source card.
 */
export function useCollapsedGroups(groupBy: string) {
  const [collapsedKeys, setCollapsedKeys] = React.useState<ReadonlySet<string>>(() => new Set());
  const keyOf = (group: {key: string}) => `${groupBy}:${group.key}`;
  return {
    isCollapsed: (group: {key: string}) => collapsedKeys.has(keyOf(group)),
    toggle: (group: {key: string}) =>
      setCollapsedKeys((previous) => {
        const next = new Set(previous);
        if (!next.delete(keyOf(group))) {
          next.add(keyOf(group));
        }
        return next;
      }),
  };
}
